export const generateRandomId = () => Math.random().toString( 36 ).substring( 2, 4 );